import styled from '@emotion/styled';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Transition } from 'react-transition-group';
import { Flex, NakedButton } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import { PropertyCardSkeleton } from 'components/PropertyCard';

const duration = 250;
const resultContainerStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const resultTransitionStyles = {
  exiting: { opacity: 1 },
  entered: { opacity: 1 },
  exited: { opacity: 0, display: 'none' },
};

export const FadeInWrapper = ({ children, isVisible }) => {
  return (
    <Transition in={isVisible} timeout={duration} exit={false}>
      {(transitionState) => <div style={{ ...resultContainerStyle, ...resultTransitionStyles[transitionState] }}>{children}</div>}
    </Transition>
  );
};

FadeInWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

export const SkeletonNav = React.memo(() => {
  return (
    <Flex height={rem('33px')}>
      <PulsingLoadingBlock height={18} mr={4} width={70} />
      <PulsingLoadingBlock height={18} mr={4} width={50} />
      <PulsingLoadingBlock height={18} mr={4} width={70} />
      <PulsingLoadingBlock height={18} mr={4} width={50} />
      <PulsingLoadingBlock height={18} mr={4} width={70} />
    </Flex>
  );
});

SkeletonNav.displayName = 'SkeletonNav';

export const NavLink = styled(NakedButton)`
  background: transparent;
  color: ${themeGet('colors.greys.charcoal')};
  padding-bottom: ${themeGet('space.2')};
  margin-right: ${themeGet('space.6')};
  border-bottom: 2px solid;
  border-color: ${(props) => (props.isActive ? themeGet('colors.brand.primary') : 'transparent')};
  transition: border-color 0.2s ease-in-out;
  font-size: ${themeGet('fontSizes.base')};
  &:hover,
  &:focus {
    border-color: ${themeGet('colors.brand.primary')};
  }

  &:hover {
    outline: none;
  }

  &:focus {
    outline: 2px solid ${themeGet('colors.blue')};
  }
`;

export const SkeletonResults = React.memo(() => (
  <Fragment>
    <PropertyCardSkeleton />
    <PropertyCardSkeleton />
    <PropertyCardSkeleton />
  </Fragment>
));

SkeletonResults.displayName = 'SkeletonResults';
